<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">สร้างใบจองสินค้า</h2>
            <div class="row">
                <div class="col-sm-6">
                    <!-- order id -->
                    <div class="form-group row" v-if="form.order_id">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ใบจอง</label>
                        <div class="col-sm-8">
                            <input
                                class="form-control"
                                v-if="form.edit_no"
                                v-model="form.order_id+'-'+form.edit_no" disabled/>
                            <input
                                class="form-control"
                                v-else
                                v-model="form.order_id" disabled/>
                        </div>
                    </div>
                    <!-- Customer select -->
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">รหัสลูกค้า</label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.customer"
                                :options="optionCustomer"
                                track-by="id"
                                :customLabel="customWithName"
                                :show-labels="false"
                                @input="getCustomerOther(form.customer)"
                                placeholder="เลือกลูกค้า">
                            </multiselect>
                        </div>
                    </div>
                    <!-- Customer data -->
                    <template v-if="form.customer">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">ลูกค้า</label>
                            <div class="col-sm-8 col-form-label">
                                <p>
                                    {{ form.customer.first_name }}
                                    {{ form.customer.last_name }}
                                </p>
                                <p>{{ form.customer.address }}</p>
                                <p>โทร {{ form.customer.phone }}</p>
                            </div>
                        </div>
                    </template>
                    <template v-if="form.customer">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">พนักงานขาย</label>
                            <div class="col-sm-8 col-form-label">
                                <span v-if="form.customer.sale">
                                    {{ form.customer.sale.sale_id }} {{ form.customer.sale.name }}
                                </span>
                            </div>
                        </div>
                    </template>
                    <!-- Customer other -->
                    <div class="form-group row"
                         v-if="(optionCustomerOther.length > 0 && form.customer) || form.customer_other_id">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ลูกค้ารายย่อย</label>
                        <div class="col-sm-8">
                            <multiselect
                                :options="optionCustomerOther"
                                v-model="form.customer_other"
                                @input="getOrderTransportPrice"
                                track-by="id"
                                label="store_name"
                                :show-labels="false"
                                placeholder="เลือกลูกค้า">
                            </multiselect>
                        </div>
                    </div>
                    <!-- other price form-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label
                           text-capitalize text-right">+โฟม</label>
                        <div class="col-sm-8">
                            <b-form-select v-model="form.other_price_form"
                                           @input="selectOtherPrice"
                                           class="w-50"
                                           :options="priceForm">
                            </b-form-select>
                        </div>
                    </div>
                    <!-- remark -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label
                           text-capitalize text-right">หมายเหตุ</label>
                        <div class="col-sm-8">
                            <textarea class="form-control" v-model="form.remark"></textarea>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.note_2 && form.order_status_id == 2">
                        <label class="col-sm-4 col-form-label
                           text-capitalize text-right">หมายเหตุ(เปิดบิลบางส่วน)</label>
                        <div class="col-sm-8">
                            <textarea class="form-control" v-model="form.note_2" readonly></textarea>
                        </div>
                    </div>
                    <!--other price -->
                    <!--<div class="form-group row">-->
                    <!--<label class="col-sm-4 col-form-label-->
                    <!--text-capitalize text-right">+เบ็ดเตล็ด</label>-->
                    <!--<div class="col-sm-8">-->
                    <!--<input type="number" class="form-control w-50"-->
                    <!--v-model="form.other_price"/>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--เครดิตเกินวงเงิน--->
                    <template v-if="ifCreditLimitExceed || ifCustomerHasInvoiceOverdue">
                        <div class="alert alert-danger">
                            <template v-if="ifCreditLimitExceed">
                                <div>ลูกค้ามีเครดิตเกินวงเงินที่จำกัด</div>
                            </template>
                            <template v-if="ifCustomerHasInvoiceOverdue">
                                <div>มีรายการค้างชำระเกิน 30 วัน</div>
                            </template>
                        </div>
                    </template>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">วันที่</label>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                class="w-100"
                                placeholder="วันที่อัพเดต">
                            </date-picker>
                        </div>
                    </div>
                    <!-- Transport select -->
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ประเภทรถ</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.transport_type"
                                track-by="id"
                                label="name"
                                :options="optionTransportType"
                                :show-labels="false"
                                :disabled="disabled_transport"
                                @input="setIDTransportation(form.transport_type)"
                                placeholder="ประเภทรถ">
                            </multiselect>
                            <div style="display: none" v-if="form.transport_type">
                                {{ transport_type_name = form.transport_type.name }}
                            </div>
                        </div>
                    </div>
                    <!--ค่าขนส่ง-->
                    <div v-if="form.customer && !form.customer_other" class="form-group row" @change="getNewPrice"
                         :hidden="setFixed">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">การคิดค่าขนส่ง</label>
                        <div class="col-md-3">
                            <input type="radio" value="1" id="1" v-model="form.customer.fixed_rate_status"
                                   :disabled="hideFixRate_customer_2"/>
                            <label for="1">แบบต่อห่อ</label>
                        </div>
                        <div class="col-md-3">
                            <input type="radio" value="2" id="2" v-model="form.customer.fixed_rate_status"
                                   :disabled="hideFixRate_customer_1"/>
                            <label for="2">แบบเหมา</label>
                        </div>
                    </div>
                    <div v-if="form.customer_other" class="form-group row" @change="getNewPrice" :hidden="setFixed">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">การคิดค่าขนส่ง</label>
                        <div class="col-md-3">
                            <input type="radio" value="1" id="3" v-model="form.customer_other.fixed_rate_status"
                                   :disabled="hideFixRate_customer_other_2"/>
                            <label for="3">แบบต่อห่อ</label>
                        </div>
                        <div class="col-md-3">
                            <input type="radio" value="2" id="4" v-model="form.customer_other.fixed_rate_status"
                                   :disabled="hideFixRate_customer_other_1"/>
                            <label for="4">แบบเหมา</label>
                        </div>
                    </div>
                    <!-- transportation select -->
                    <div class="form-group row" v-if="form.transport_type && form.transport_type.id === type_transport">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">การขนส่ง</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.transportation"
                                :options="optionTransportation"
                                track-by="id"
                                label="name"
                                :show-labels="false"
                                placeholder="การขนส่ง">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row" v-if="form.transportation && form.transport_type.id === 4">
                        <div class="col-sm-4 text-right">
                            <label class="col-form-label text-capitalize text-right">เบอร์โทรและสายการขนส่ง</label>
                        </div>
                        <div class="col-sm-6">
                            <div class="col-sm-12 border padding">
                                <span style="margin-right: 10px">{{ form.transportation.phone }}</span>
                                <span>{{ form.transportation.address }}</span>
                                <template>
                                <span v-if="form.transportation.transport_line_id == 1">
                                    พุทธมณฑล
                                </span>
                                    <span v-if="form.transportation.transport_line_id == 2">
                                    ศาลายา
                                </span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <!-- -Status -->
                    <div class="form-group row"
                         v-if="id">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">สถานะใบจอง</label>
                        <div class="col-sm-6">
                            <input v-if="!canViewSuperAdmin"
                                   type="text"
                                   class="form-control"
                                   v-model="form.status.name"
                                   disabled/>
                            <select class="form-control"
                                    v-else-if="canViewSuperAdmin"
                                    v-model="form.order_status_id">
                                <template v-for="(x,i) in OrderStatus">
                                    <option :value="x.value">{{ x.text }}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                    <!--มีพ่วงการขนส่ง-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_transport_other}">
                                <input type="checkbox"
                                       v-model="form.status_transport_other"
                                       :value="1"
                                       class="form-check-input"
                                       id="transportation">
                                <label class="form-check-label" for="transportation">มีพ่วงการขนส่ง</label>
                            </div>
                        </div>
                    </div>
                    <!--status_have_old--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_have_old}">
                                <input type="checkbox"
                                       v-model="form.status_have_old"
                                       :value="1"
                                       class="form-check-input"
                                       id="exampleCheck1">
                                <label class="form-check-label" for="exampleCheck1">มีการเก็บเก่า</label>
                            </div>
                        </div>
                    </div>
                    <!--status payment-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_payment}">
                                <input type="checkbox"
                                       v-model="form.status_payment"
                                       :value="1"
                                       class="form-check-input"
                                       id="status_payment"/>
                                <label class="form-check-label" for="status_payment">เก็บเงินสด/เช็ค</label>
                            </div>
                        </div>
                    </div>
                    <!--status_return-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_return}">
                                <input type="checkbox"
                                       v-model="form.status_return"
                                       :value="1"
                                       class="form-check-input"
                                       id="status_return"/>
                                <label class="form-check-label" for="status_return">มีคืนสินค้า</label>
                            </div>
                        </div>
                    </div>
                    <!---status_before_transport--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_before_transport}">
                                <input type="checkbox"
                                       v-model="form.status_before_transport"
                                       :value="1"
                                       id="status_before_transport"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_before_transport">โอนเงินก่อนส่งของ</label>
                            </div>
                        </div>
                    </div>
                    <!---status_tax_receipt--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_tax_receipt}">
                                <input type="checkbox"
                                       v-model="form.status_tax_receipt"
                                       :value="1"
                                       id="status_tax_receipt"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_tax_receipt">ขอใบกำกับภาษี</label>
                            </div>
                        </div>
                    </div>
                    <!---status_receive--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_receive}">
                                <input type="checkbox"
                                       v-model="form.status_receive"
                                       @click="clearTransport"
                                       :value="1"
                                       id="status_receive"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_receive">มารับเอง</label>
                            </div>
                        </div>
                    </div>
                    <!---status_not_pay--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_not_pay}">
                                <input type="checkbox"
                                       v-model="form.status_not_pay"
                                       :value="1"
                                       id="status_not_pay"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_not_pay">บิลไม่มีราคา</label>
                            </div>
                        </div>
                    </div>
                    <!---status_sale_receive--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_sale_receive}">
                                <input type="checkbox"
                                       v-model="form.status_sale_receive"
                                       :value="1"
                                       @change="getOrderTransportPrice"
                                       id="status_sale_receive"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_sale_receive">เซลล์ขนส่ง</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- table -->
            <div style="color: red; font-size: 15px">หากมีการยืนยันใบจองแล้ว เซลล์จะไม่สามารถแก้ไขได้</div>
            <!--            <div v-if="canViewSuperAdmin" style="color: red; font-size: 15px">**หากแก้ไขราคา จะบันทึกราคาใหม่หลังจากกด ยืนยันการจอง</div>-->
            <div class="table table-responsive" style="min-height: 350px; padding-top: 50px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th style="width: 150px" scope="col">รหัสสินค้า</th>
                        <th scope="col">ชื่อสินค้า</th>
                        <th scope="col" width="100px">จำนวนทั้งหมด</th>
                        <th scope="col">จำนวนค้างส่ง</th>
                        <th scope="col" width="150px">ราคา/หน่วย</th>
                        <th width="100px" scope="col">+เบ็ดเตล็ด</th>
                        <th scope="col" width="120px">ส่วนลดพิเศษ</th> <!--สำหรับเซลล์--->
                        <th scope="col" width="150px">โปรโมชั่น</th>
                        <th width="50px" scope="col">ลด</th>
                        <th scope="col">ราคา/รวม</th>
                        <th scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--order multi--->
                    <template v-for="(details, index) in form.details">
                        <tr>
                            <!--ลำดับ-->
                            <td>{{ index + 1 }}</td>
                            <!--รหัสสินค้า-->
                            <td align="center" style="width: 150px;">
                                <template v-if="details.product">
                                    {{ details.product.sku }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <!--ชื่อสินค้า-->
                            <td align="center" style="width: 150px;">
                                <template v-if="details.product">
                                    {{ details.product.name }}
                                </template>
                                <template v-else>
                                    <span style="color: red">สินค้านี้ได้ถูกลบออกจากคลังแล้ว</span>
                                </template>
                            </td>
                            <!--จำนวนทั้งหมด-->
                            <td>
                                {{ details.total_quantity_order ? details.total_quantity_order : 0 | amount }}
                            </td>
                            <!--จำนวนค้างส่ง-->
                            <td align="center">
                                <input type="number" style="width: 100px;"
                                       v-model="details.quantity"
                                       v-on:focusout="calculatePromotionArray(form.details)"
                                       class="form-control"/>
                            </td>
                            <!--ราคา/หน่วย-->
                            <td align="center">
                                <template v-if="form.customer && form.customer.special_customer == 1">
                                    <input class="form-control" v-model="details.price"/>
                                </template>
                                <template v-else>
                                    <template v-if="details.product">
                                    <span v-if="details.product.product_type_id == type_form">
                                        {{ parseFloat(details.price) + parseFloat(details.other_price_form) - parseFloat(details.discount_special) | currency }}
                                    </span>
                                        <span v-else>{{ details.price | currency }}</span>
                                    </template>
                                </template>
                            </td>
                            <!--+เบต็ด-->
                            <td>
                                <input type="number" class="form-control"
                                       :disabled="details.checkSpecial"
                                       v-on:input="calculatePromotionArray(form.details)"
                                       v-model="details.other_price"/>
                            </td>
                            <!--ส่วนลดพิเศษ--->
                            <td>
                                <template v-if="details.product && details.product.product_type_id == type_form">
                                    <template v-if="product_promotion_other.includes(details.product.id)">
                                        <b-form-select v-model="details.discount_price"
                                                       v-on:input="calculatePromotionArray(form.details)"
                                                       :options="discount_price">
                                        </b-form-select>
                                    </template>
                                </template>
                                <template v-else>
                                    <template
                                        v-if="details.product && product_promotion_other.includes(details.product.id)">
                                        <input type="number" class="form-control"
                                               v-on:input="calculatePromotionArray(form.details)"
                                               v-model="details.discount_special"/>
                                    </template>
                                </template>
                            </td>
                            <!--โปรโมชั่น-->
                            <td>
                                <template v-if="form.customer && form.customer.ban_promotion">
                                    <span style="color: red">ลูกค้าคนนี้ถูกแบนโปรโมชั่น</span>
                                </template>
                                <template v-else>
                                    <b-form-select v-model="details.promotion_id"
                                                   v-on:input="calculatePromotionArray2(form.details)">
                                        <option v-for="data in details.option_promotion"
                                                :value="data.value">
                                            {{ data.text }}
                                        </option>
                                    </b-form-select>
                                </template>
                            </td>
                            <!--ส่วดลด-->
                            <td align="center">
                                {{ details.discount | currency }}฿
                            </td>
                            <!--ราคา/รวม-->
                            <td>
                                <template>{{ details.total | currency }}</template>
                            </td>
                            <!--เพิ่ม / ลบ-->
                            <td>&nbsp;
                                <!--                                <span @click="disabled_edit = !disabled_edit" role="button" v-if="canViewSuperAdmin">-->
                                <!--                                     <icon name="pencil-alt"></icon>-->
                                <!--                                </span>&nbsp&nbsp-->
                                <a @click="showModalDelete(index,details)">
                                    <icon name="trash-alt"></icon>
                                </a>
                            </td>
                        </tr>
                        <!--input product-->
                    </template>
                    <!---order one-->
                    <tr>
                        <!--ลำดับ-->
                        <td></td>
                        <!--รหัสสินค้า--->
                        <td style="width: 150px">
                            <multiselect
                                v-model="detail.product"
                                :options="optionProducts"
                                track-by="id"
                                :customLabel="LabelSkuWithName"
                                :show-labels="false"
                                @input="setProductName(detail.product)"
                                placeholder="โปรดเลือกรายการสินค้า"
                                style="width: 100%;min-width: 150px">
                            </multiselect>
                        </td>
                        <!--ชื่อสินค้า--->
                        <td>{{ product_name }}</td>
                        <!--จำนวนทั้งหมดที่สั่งจอง-->
                        <td>{{ detail.remaining | amount }}</td>
                        <!--จำนวนค้างส่ง--->
                        <td align="center">
                            <input type="number"
                                   :disabled="!detail.product"
                                   v-on:focusout="calculatePromotion(detail)"
                                   class="form-control" style="width: 100px;"
                                   value="null"
                                   v-model="detail.quantity"/>
                        </td>
                        <!--ราคา/หน่วย--->
                        <td align="center">
                            <template v-if="form.customer && form.customer.special_customer">
                                <input class="form-control" v-model="detail.price"/>
                            </template>
                            <template v-else>
                                <template v-if="detail.product">
                                    <span v-if="detail.product.product_type_id == type_form">
                                        {{ parseFloat(detail.price) + parseFloat(detail.other_price_form) - parseFloat(detail.discount_special) | currency }}
                                    </span>
                                    <span v-else>{{ detail.price | currency }}</span>
                                </template>
                            </template>
                        </td>
                        <!--+เบ็ดเตล็ด--->
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="detail.checkSpecial"
                                   v-on:input="calculatePromotion(detail)"
                                   v-model="detail.other_price"/>
                        </td>
                        <!--ส่วนลดพิเศษ--->
                        <td>
                            <template v-if="detail.product && detail.product.product_type_id == type_form">
                                <template v-if="detail.product && product_promotion_other.includes(detail.product.id)">
                                    <b-form-select v-model="detail.discount_price"
                                                   v-on:input="calculatePromotion(detail)"
                                                   :options="discount_price">
                                    </b-form-select>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="detail.product && product_promotion_other.includes(detail.product.id)">
                                    <input type="number" class="form-control"
                                           v-on:input="calculatePromotion(detail)"
                                           v-model="detail.discount_special"/>
                                </template>
                            </template>
                        </td>
                        <!--โปรโมชั่น--->
                        <td>
                            <template v-if="form.customer && form.customer.ban_promotion">
                                <span style="color: red">ลูกค้าคนนี้ถูกแบนโปรโมชั่น</span>
                            </template>
                            <template v-else>
                                <b-form-select v-model="detail.promotion_id"
                                               v-on:input="calculatePromotion(detail)">
                                    <option v-for="data in detail.option_promotion"
                                            :value="data.value">
                                        {{ data.text }}
                                    </option>
                                </b-form-select>
                            </template>
                        </td>
                        <!--ลด--->
                        <td>
                            <template v-if="detail.discount_status_id==1">
                                {{ detail.discount | currency }}฿
                            </template>
                            <template v-else-if="detail.discount_status_id==2">
                                {{ detail.discount | currency }}%
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <!--ราคา/รวม--->
                        <td>
                            {{ detail.total | currency }}
                        </td>
                        <!--เพิ่ม / ลบ--->
                        <td>
                            <button type="button"
                                    class="btn btn-primary"
                                    @click="onAddProduct(detail)">+
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br/>
            <div>
                <span style="color: red;font-size: 15px">สินค้าประเภท 'ชุดรวมสินค้า' จะคิดราคาขนส่งรวมเป็น 2 เท่า เพราะมีสินค้า 2 ชนิดใน 1 SKU</span>
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">ประเภทสินค้า</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">ราคา/หน่วย</th>
                        <th scope="col">ราคาขนส่งรวม</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--transport table-->
                    <template v-for="(transport, index) in transport_price_table">
                        <tr :class="{ 'transport-style': transport.product_type_id == 12 }">
                            <td>
                                {{ ++index }}
                            </td>
                            <td>
                                <template v-if="transport.product_type_id">
                                    {{ transport.product_type_name }}
                                    <span v-if="transport.form_size_id">({{ transport.form_size_name }})</span>
                                    <span v-if="transport.pack_type">({{ transport.pack_type_name }})</span>
                                    <span v-if="transport.product_type_id == 12">(*2)</span>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                {{ transport.quantity | amount }}
                            </td>
                            <td>
                                <template v-if="transport.transport_unit_price">
                                    {{ transport.transport_unit_price | currency }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                {{ transport.transport_total | currency }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
                <div>**เงื่อนค่าขนส่ง</div>
                <div>1.แก้วและเบ็ดเตล็ดที่เป็นลัง จะคิดค่าขนส่งเป็น 70% ของราคาขนส่งโฟมเล็ก</div>
                <div>2.กรณีหลอดที่เป็นลูก คิดเรทตามโฟมใหญ่ ถ้าไม่มีโฟมใหญ่ให้คิดคามเรทขนส่งโฟมเล็ก</div>
                <div>3.กรณีสินค้าหน่วยเป็นลังคิดเป็น 70% ของโฟมเล็ก และ เป็นลังคิดเรทขนส่งราคาเดียวกับโฟมเล็ก</div>
                <div>4.ฝา หน่วย เป็นลัง คิดเป็น 70% ของโฟมเล็ก</div>
            </div>
            <br>
            <div class="form-group row text-primary text-right"
                 style="padding-top: -10px;font-size: 15px; font-weight: normal"
                 v-if="form.status_receive">
                <div class="col form-check" :class="{'text-primary' :form.status_foam_discount}">
                    <input type="checkbox"
                           v-model="form.status_foam_discount"
                           :value="1"
                           id="foam_discount"
                           class="form-check-input"/>
                    <label class="form-check-label" for="foam_discount">ส่วนลดโฟมแพ็คละ 10 บาท จำนวน
                        {{ sum_quantity_form }} แพ็ค = {{ sum_price_form | currency }} บาท</label>
                </div>
            </div>
            <div class="form-group row text-primary text-right"
                 style="margin-top: -10px ;font-size: 15px; font-weight: normal"
                 v-if="form.status_receive">
                <div class="col form-check" :class="{'text-primary' :form.status_glass_discount}">
                    <input type="checkbox"
                           v-model="form.status_glass_discount"
                           :value="1"
                           id="glass_discount"
                           class="form-check-input"/>
                    <label class="form-check-label" for="glass_discount">ส่วนลดแก้วแพ็คละ 5 บาท จำนวน
                        {{ sum_quantity_glass }} แพ็ค = {{ sum_price_glass | currency }} บาท</label>
                </div>
            </div>
            <div class="form-group row total-padding" v-if="form.status_receive">
                <div class="col font-weight-bold">
                    <span>ส่วนลดพิเศษมารับเอง</span>
                </div>
                <div>
                    <input class="form-control" placeholder="ส่วนลด (บาท)"
                           v-model="form.discount_special" disabled/>
                </div>
            </div>
            <div class="form-group row total-padding">
                <div class="col font-weight-bold">
                    <span>ส่วนลดอื่นๆที่ต้องการลดเพิ่มเติม</span>
                </div>
                <div>
                    <input class="form-control"
                           :disabled="canViewSuperAdmin || this.user.username == '20533' ? false : true"
                           v-model="form.other_discount"
                           placeholder="ส่วนลดอื่นๆ"/>
                </div>
            </div>
            <div class="form-group row total-padding" v-if="form.other_discount_user">
                <div class="col font-weight-bold">
                    <span>ผู้ใส่ส่วนลด : {{ form.other_discount_user_model.name }}</span>
                </div>
            </div>
            <div class="total-padding">
                <span style="padding-left: 25px">รวมทั้งหมด :{{ totalPrice | currency }} บาท</span><br>
                <span style="padding-left: 25px">ค่าขนส่ง : {{ total_transport_price | currency }} บาท</span><br>
                <span
                    style="padding-left: 25px">ยอดรวมสุทธิ : {{ parseFloat(totalPrice) + parseFloat(total_transport_price) | currency }} บาท</span>
            </div>
            <div style="display: none">{{ validateDiscountSpecialDetail }}</div>
            <div style="display: none">{{ validateDiscountSpecialDetails }}</div>
            <div style="display: none">{{ sumQuantityProduct }}</div>
            <br/><br/>
            <!--Modal Delete-->
            <b-modal
                ref="delete_item"
                hide-header
                hide-footer>
                <div style="text-align: center;">
                    <h4>คุณต้องการลบใช่หรือไม่</h4>
                    <span
                        v-if="delete_index != null && form.details.length > 0">{{ form.details[delete_index].product.sku + ' - ' + form.details[delete_index].product.name }}</span>
                    <br/>
                    <br/>
                    <button type="button"
                            class="btn btn-success"
                            @click="removeProduct">ตกลง
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            class="btn btn-secondary"
                            @click="hideModalDelete">ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--Modal Confirm-->
            <b-modal
                ref="confirm_submit_order"
                hide-header
                hide-footer>
                <div style="text-align: center;">
                    <h5>{{ modalConfirmOrder.msg }}</h5>
                    <br/>
                    <div role="group"
                         class="mb-5"
                         v-show="modalConfirmOrder.showNote">
                        <b-form-input
                            id="input-note"
                            v-model="form.note"
                            :state="modalConfirmOrder.state"
                            aria-describedby="input-note-help input-note-feedback"
                            trim
                        ></b-form-input>

                        <!-- This will only be shown if the preceding input has an invalid state -->
                        <b-form-invalid-feedback id="input-note-feedback">
                            โปรดใส่หมายเหตุ
                        </b-form-invalid-feedback>
                    </div>
                    <button type="button"
                            v-show="modalConfirmOrder.showNote"
                            class="btn btn-success"
                            @click="submitOrder">ตกลง
                    </button>

                    <button type="button"
                            class="btn btn-secondary"
                            v-show="!modalConfirmOrder.showNote"
                            @click="hideModalConfirm">
                        ตกลง
                    </button>
                </div>
            </b-modal>
            <div class="text-right" v-if="form.order_status_id==1 || !id">
                <button type="button" v-if="!form.status_confirm && !canSaleOrdersAllView"
                        class="btn btn-outline-info mb-3"
                        @click="saveDraft"
                        style="margin-right: 20px">
                    <icon name="cloud-upload-alt"></icon>
                    บันทึกแบบร่าง
                </button>
                <button type="button"
                        v-if="validateConfirm"
                        class="btn btn-success mb-3"
                        @click="confirmOrder"
                        style="margin-right: 20px">
                    <icon name="check"></icon>
                    ยืนยันการจอง
                </button>
            </div>
            <div class="text-right" v-else-if="newDO">
                <button type="button"
                        class="btn btn-success mb-3"
                        @click="confirmOrder"
                        style="margin-right: 20px">
                    <icon name="check"></icon>
                    ยืนยันการจอง
                </button>
            </div>
            <!-- Modal Confirm Order -->
            <b-modal
                ref="confirm_order"
                scrollable
                hide-header
                hide-footer>
                <order-confirm-modal @confirm-order="confirmOrderModalHandler"/>
            </b-modal>
        </div>
        <b-modal hide-footer hide-header ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import SelectProduct from "../SelectProduct";
import OrderConfirmModal from "./OrderConfirmModal";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import {canSaleOrdersAllView, canSaleView, canViewSuperAdmin,} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "order-form",
    props: {
        id: {default: null},
        newDO: {default: null},
    },
    components: {
        Loading,
        SelectProduct,
        Multiselect,
        OrderConfirmModal,
        DatePicker
    },
    data() {
        return {
            msg: 'กำลังบันทึกข้อมูลกรุณารอสักครู่',
            status_loading: 1,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            data_transport_fee: null,
            sum_quantity_glass: 0,
            sum_quantity_form: 0,
            sum_price_form: 0,
            sum_price_glass: 0,
            total: 0,
            min: 0,
            max: 5,
            items: [
                {
                    text: "รายการใบจองสินค้า",
                    to: {name: "orders"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            detail: {
                uniq: '',
                product_id: "",
                quantity: null,
                price: 0,
                promotion: null,
                discount: 0,
                discount_status_id: 1,
                total: 0,
                promotion_id: null,
                other_price: null,
                other_price_form: 0,
                other_price_total: 0,
                remaining: 0,
                product: "",
                discount_special: 0,
                discount_price: 0,
                checkSpecial: true,
                option_promotion: [
                    {
                        value: null,
                        text: "โปรโมชั่น"
                    },
                ],
            },
            delete_index: null,
            date: "",
            transport_type: "",
            product_name: "",
            discount_type: [
                {value: '1', text: '฿'},
                {value: '2', text: '%'}
            ],
            Invalid: true,
            modalConfirmOrder: {
                msg: "",
                showNote: false,
                canSubMit: false,
                state: null
            },
            priceForm: [
                {value: null, text: "ไม่มีราคา"},
                {value: 1, text: "+1"},
                {value: 2, text: "+2"},
                {value: 3, text: "+3"},
                {value: 4, text: "+4"},
                {value: 5, text: "+5"},
                {value: 6, text: "+6"},
                {value: 7, text: "+7"},
                {value: 8, text: "+8"},
                {value: 9, text: "+9"},
                {value: 10, text: "+10"},
            ],
            type_form: 1,
            type_transport: 4,
            test: [],
            optionCustomer: [],
            optionTransportation: [],
            optionCustomerOther: [],
            transport_price_table: [],
            disabled_edit: true,
            setFixed: true,
            hideFixRate_customer_1: false,
            hideFixRate_customer_2: false,
            hideFixRate_customer_other_1: false,
            hideFixRate_customer_other_2: false,
            promotion_all_one: [],
            on_loading: true,
        };
    },
    created() {
        const reloaded = localStorage.getItem('reloaded');
        if (reloaded === 'true') {
            this.goback();
        }
        if (this.id) window.addEventListener('unload', this.setback)
        this.$store.dispatch("TransportType/setTransportTypes");
        this.$store.dispatch("Common/setOrderStatus");
        this.$store.dispatch("Order/setDiscountPrice");
        if (this.form.details.length == 0) {
            this.$store.dispatch("Products/getProductAll");
            this.$store.dispatch('Order/clear_check_freez')
        }
        this.check_freez_list();
        this.getTransportationAll();
        this.getCustomerAll();
        this.getCustomerOther(this.form.customer);
        if (this.form.customer) {
            this.getPromotionOther();
        }
        if (this.form.order_status_id == 1) {
            if (this.form.details.length > 0) {
                this.calculatePromotionArray(this.form.details);
            }
        }
        this.setIDTransportation(this.form.transport_type);
        this.transport_price_table = this.form.order_transport_details;
        if (this.newDO) {
            this.$store.dispatch("Order/clear_new_do", this.id)
            this.setFixed = true
            this.id = null;
        }
        this.getPromotionAll();
    },
    computed: {
        canSaleView,
        canSaleOrdersAllView,
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.Order.orderForm;
            },
            user: state => {
                return state.Auth.user
            },
            OrderStatus: state => {
                return [
                    ...state.Common.order_status.map(order => ({
                        value: order.id,
                        text: order.name
                    }))
                ];
            },
            optionTransportType: state => {
                return state.TransportType.transportTypeList;
            },
            optionProducts: (state) => {
                if (state.Order.orderForm.details.length != 0 && state.Order.check_freez && !state.Order.tuyen) {
                    return state.Products.product_all.filter(value => {
                        return value.cancel_status == null && (value.product_type_id == 14 || value.product_type_id == 17);
                    });
                } else {
                    return state.Products.product_all.filter(value => {
                        return value.cancel_status == null;
                    });
                }
            },
            promotions: state => {
                return [
                    {
                        value: null,
                        text: "โปรโมชั่น"
                    },

                    ...state.Promotion.promotion_all.map(promotion => ({
                        value: promotion.id,
                        text: promotion.name,
                    }))
                ]
            },
            promotion_detail: state => {
                return state.Order.promotion_detail;
            },
            product_promotion_other: state => {
                return state.Order.product_promotion_other;
            },
            max_discount: state => {
                return state.Order.max_discount;
            },
            discount_price: state => {
                return state.Order.discount_price;
            },
            check_freez: state => {
                return state.Order.check_freez;
            },
            tuyen: state => {
                return state.Order.tuyen;
            }
        }),
        disabled_transport() {
            if (this.form.status_receive || this.form.status_sale_receive) {
                return true;
            }
            return false;
        },
        ifCreditLimitExceed() {
            if (this.form.customer) {
                return this.totalPrice > this.form.customer.credit_limit
            }
            return false
        },
        ifCustomerHasInvoiceOverdue() {
            if (this.form.customer) {
                return !!this.form.customer.invoice_overdue
            }
            return false
        },
        totalPrice() {
            let discount_special = 0;
            let other_discount = 0;
            let total = this.form.details.reduce((carry, detail) => {
                return carry + detail.total
            }, 0);
            if (this.form.status_receive) {
                if (this.form.discount_special > 0) {
                    discount_special = this.form.discount_special;
                }
                total = parseFloat(total) - parseFloat(discount_special)
            }
            if (this.form.other_discount > 0) {
                other_discount = this.form.other_discount;
                total = parseFloat(total) - parseFloat(other_discount)
            }
            return parseFloat(total).toFixed(2);

        },
        totalDiscount() {
            return (parseFloat(this.detail.price) +
                parseFloat(this.detail.other_price_total) -
                parseFloat(this.detail.discount_special)) * parseFloat(this.detail.quantity);
        },
        validateDiscountSpecialDetail() {
            if (!this.detail.discount_price) {
                if (this.detail.discount_special) {
                    if (this.detail.discount_special > this.max_discount) {
                        this.detail.discount_special = this.max_discount
                    }
                }
            }
            return true;
        },
        validateDiscountSpecialDetails() {
            this.form.details.forEach(detail => {
                if (!detail.discount_price) {
                    if (detail.discount_special) {
                        if (detail.discount_special > this.max_discount) {
                            detail.discount_special = this.max_discount
                        }
                    }
                }
            });
            return true;
        },
        sumQuantityProduct() {
            //หากเลือกมารับเอง
            this.sum_quantity_glass = 0;
            this.sum_quantity_form = 0;
            this.sum_price_form = 0;
            this.sum_price_glass = 0;
            this.form.discount_special = 0;
            let form_type = 1;
            let glass_type = 2;
            this.form.details.forEach(detail => {
                if (detail.product && detail.product.product_type_id == form_type && this.form.status_foam_discount) {
                    this.sum_quantity_form += parseFloat(detail.quantity);
                }
                if (detail.product && detail.product.product_type_id == glass_type && this.form.status_glass_discount) {
                    this.sum_quantity_glass += parseFloat(detail.quantity);
                }
            });
            this.sum_price_form = parseFloat(this.sum_quantity_form) * 10;
            this.sum_price_glass = parseFloat(this.sum_quantity_glass) * 5;
            if (this.form.status_receive) {
                this.form.discount_special = parseFloat(this.sum_price_form) + parseFloat(this.sum_price_glass);
            }
            return this.form.discount_special;
        },
        total_transport_price() {
            let transport_price = 0;
            if (this.transport_price_table && this.transport_price_table.length > 0) {
                transport_price = this.transport_price_table.reduce((carry, transport) => {
                    if (!transport.transport_total) {
                        transport.transport_total = 0;
                    }
                    return carry + parseFloat(transport.transport_total);
                }, 0);
                return parseFloat(transport_price).toFixed(2);
            }
            return 0;
        },
        validateConfirm() {
            if (this.newDO) {
                return true
            } else if (this.form.status_confirm) {
                return this.canSaleOrdersAllView;
            } else {
                return this.canSaleView;
            }
        }
    },
    methods: {
        clearTransport() {
            // if (this.form.status_receive){
            this.form.transport_type = null;
            this.form.transportation = null;
            // }
        },
        goback() {
            localStorage.setItem('reloaded', 'false')
            this.$router.push('/orders')
        },
        setback() {
            localStorage.setItem('reloaded', 'true')
        },
        getPromotionAll() {
            this.$store.dispatch("Promotion/PromotionAll").then(res => {
                this.promotion_all_one = res;
            });
        },
        check_freez_list() {
            if (this.form.details.length == 0) {
                this.$store.dispatch('Order/clear_check_freez')
            }
        },
        getNewPrice() {
            let fix_rate = 0;
            if (this.form.customer_other)
                fix_rate = this.form.customer_other.fixed_rate_status;
            else
                fix_rate = this.form.customer.fixed_rate_status;
            let data = {
                fix_rate: fix_rate,
                customer_id: this.form.customer_other ? this.form.customer_other.id : this.form.customer.id,
                customer_type: this.form.customer_other ? 2 : 1,
            }
            this.$store.dispatch('Customer/setFixedRate', data);
            this.getOrderTransportPrice();
        },
        customWithName(option) {
            return `${option.store_name} - ${option.customer_id}`
        },
        LabelSkuWithName(option) {
            return `${option.sku} - ${option.short_name}`
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.optionCustomer = res.filter(data => !data.cancel_status);
            });
        },
        getTransportationAll() {
            this.$store.dispatch("Transportation/getAll").then(res => {
                this.optionTransportation = res;
            });
        },
        getCustomerOther(customer) {
            if (customer) {
                // //console.log(customer)
                //1 เหมา
                //2 ต่อห่อ
                let all_false_1 = false;
                let all_false_2 = false;
                customer.customer_transport_form.forEach((x, i) => {
                    if (x.transport_type_wrap_id == 1 && x.price && !all_false_1) {
                        all_false_1 = true;
                    }
                    if (x.transport_type_wrap_id != 1 && x.price && !all_false_2) {
                        all_false_2 = true;
                    }
                })
                // //console.log(all_false_1,all_false_2)
                this.hideFixRate_customer_1 = !all_false_1;
                this.hideFixRate_customer_2 = !all_false_2;
                if (!all_false_1 && !all_false_2) customer.fixed_rate_status = null;
                this.$store.dispatch("Customer/getCustomerOtherById", customer.id).then(res => {
                    this.optionCustomerOther = res;
                });
                // this.getOrderBefore();
                this.getPromotionOther();
                this.getOrderTransportPrice();
                if (this.detail.product) {
                    this.getPromotionByProductId(this.detail.product);
                }
            }
        },
        confirmOrderModalHandler(confirm) {
            if (confirm) {
                this.submitOrder()
            }
            this.hideModalConfirmOrder()
        },
        onAddProduct(submitData) {
            this.clearModalConfirm();
            if (!submitData.product) {
                alert('กรุณาเลือกรายการสินค้า');
                this.modalConfirmOrder.msg = "กรุณาเลือกรายการสินค้า";
                this.$refs['confirm_submit_order'].show();
                return false;
            } else if (submitData.quantity < 1 || !submitData.quantity) {
                // alert('กรุณาใส่จำนวน');
                this.modalConfirmOrder.msg = "กรุณาใส่จำนวน";
                this.$refs['confirm_submit_order'].show();
                return false;
            } else {
                submitData.product_id = submitData.product.id;
                let uniq = this.form.details.length;
                submitData.uniq = uniq + 1;
                this.$store.dispatch("Order/addProduct", submitData)
                    .then(() => {
                        this.product_name = "";
                        this.detail = {
                            uniq: uniq + 2,
                            product_id: "",
                            quantity: null,
                            price: 0,
                            promotion: null,
                            discount: 0,
                            discount_status_id: 1,
                            checkSpecial: true,
                            total: 0,
                            promotion_id: null,
                            other_price: null,
                            other_price_form: 0,
                            other_price_total: 0,
                            remaining: 0,
                            product: "",
                            discount_special: 0,
                            discount_price: 0,
                            option_promotion: [
                                {
                                    value: null,
                                    text: "โปรโมชั่น"
                                },
                            ],
                        };
                    }).then(() => {
                    let check = this.check_freez;
                    let tuyen = this.tuyen;
                    let checker = null;
                    this.form.details.forEach(val => {
                        if (checker) {
                            tuyen = true
                        } else {
                            checker = val.product.id == 297
                            tuyen = val.product.id == 297
                        }
                        check = val.product.product_type_id == 14 || val.product.product_type_id == 17;
                    })
                    // //console.log(check,'check freez')
                    this.$store.dispatch('Order/update_check_freez', {check: check, tuyen: tuyen}).then(res => {
                        this.$store.dispatch('Products/filter_option', res).then(() => {
                            this.$store.dispatch('Order/filter_option', res).then(() => {
                                this.calculatePromotionArray(this.form.details);
                                this.getOrderTransportPrice();
                            })
                        })
                    })
                })
            }
        },
        showModalConfirmOrder() {
            this.$refs.confirm_order.show()
        },
        hideModalConfirmOrder() {
            this.$refs.confirm_order.hide()
        },
        showModalDelete(index, details) {
            this.delete_index = index;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        hideModalConfirm() {
            this.$refs.confirm_submit_order.hide();
        },
        clearModalConfirm() {
            this.modalConfirmOrder = {
                msg: "",
                showNote: false,
                canSubMit: false,
                state: null
            };
        },
        removeProduct() {
            this.$store.dispatch("Order/removeProduct", this.delete_index)
                .then(() => {
                    this.delete_index = null;
                    this.getOrderTransportPrice();
                });
            this.hideModalDelete();
        },
        setIDTransportation(type) {
            if (type !== null) {
                this.transport_type = type.id;
            }
            //แสดงการขนส่งว่า เหมา หรือ ต่อห่อ
            if (type !== null && (type['id'] == 1 || type['id'] == 2 || type['id'] == 3)) {
                this.setFixed = false;
            } else {
                this.setFixed = true;
            }
            this.getOrderBefore();
            this.getOrderTransportPrice();
        },
        setProductName(product) {
            if (product) {
                this.product_name = product.name;
                this.detail.price = product.price;
                this.getPromotionByProductId(product);
            }
            if (this.form.customer && this.form.customer.id == 24 && (product.id == 14 || product.id == 72) && product.product_type_id == 1) {
                this.detail.checkSpecial = false;
            } else if (product.product_type_id == 1) {
                this.detail.checkSpecial = true;
            } else {
                this.detail.checkSpecial = false;
            }
        },
        confirmOrder() {
            if (!this.form.customer) {
                alert("กรุณาเลือกลูกค้า");
            } else if (!this.form.status_receive && !this.form.transport_type && !this.form.status_sale_receive) {
                alert("กรุณาเลือกประเภทรถ");
            } else if (!this.form.status_receive && !this.form.status_sale_receive && this.form.transport_type.id == this.type_transport && !this.form.transportation) {
                alert("กรุณาเลือกชื่อการขนส่ง")
            } else if (this.form.details.length < 1) {
                alert("กรุณาเพิ่มรายการสินค้า");
            } else {
                this.showModalConfirmOrder();
            }
        },
        showLoadingModal() {
            this.$refs.loading.show()
        },
        hideLoadingModal() {
            this.$refs.loading.hide()
        },
        //save
        submitOrder() {
            this.showLoadingModal();
            this.form.user_id = this.user.id;
            this.form.order_transport_details = this.transport_price_table;
            if (this.form.customer_other) {
                this.form.customer_other_id = this.form.customer_other.id;
            } else {
                this.form.customer_other_id = "";
            }
            if (this.form.date) {
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
            }
            this.form.status_confirm = 1;
            if (this.form.status_receive) {
                this.form.transport_type_id = "";
                if (this.form.customer && !this.form.customer_other) {
                    let customer_other = "";
                    if (this.form.customer_other) {
                        customer_other = this.form.customer_other.id;
                    }
                    let data = {
                        customer_id: this.form.customer.id,
                        customer_other_id: customer_other,
                        fixed_rate_status: 1,
                        transport_type_id: 1,
                        status_transport_other: this.form.status_transport_other,
                        status_sale_receive: this.form.status_sale_receive,
                        details: this.form.details,
                        flag: 1 //มาจาก invoice เพื่อคำนวนค่าขนส่ง
                    };
                    this.data_transport_fee = data;
                    this.$store.dispatch("Order/getOrderTransportPrice", data).then(res => {
                        if (res) {
                            this.form.temp_order_transport_details = res;
                        } else {
                            this.form.temp_order_transport_details = [];
                        }
                        this.$store.dispatch("Order/save", {id: this.id, newDO: this.newDO})
                            .then(response => {
                                if (response) {
                                    this.goToOrderList();
                                    this.modalConfirmOrder.state = null;
                                } else {
                                    this.form.status_confirm = null;
                                    alert("ไม่สามารถบันทึกได้ กรุณาตรวจสอบ ดังนี้\n" +
                                        "1.รถเล็กไม่เกิน 3 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                        "2.รถใหญ่ไม่เกิน 1 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                        "3.มารับเองไม่เกิน 1 ใบต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n"
                                    );
                                    this.hideLoadingModal()
                                }

                            }).catch(() => {
                            this.showLoadingModal();
                            this.msg = 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง'
                            this.status_loading = 3;
                        });
                        this.$refs['confirm_submit_order'].hide();
                    });
                } else if (this.form.customer && this.form.customer_other) {
                    let customer_other = this.form.customer_other.id;
                    let data = {
                        customer_id: this.form.customer.id,
                        customer_other_id: customer_other,
                        fixed_rate_status: 1,
                        transport_type_id: 1,
                        status_transport_other: this.form.status_transport_other,
                        status_sale_receive: this.form.status_sale_receive,
                        details: this.form.details,
                        flag: 1 //มาจาก invoice เพื่อคำนวนค่าขนส่ง
                    };
                    this.data_transport_fee = data;
                    this.$store.dispatch("Order/getOrderTransportPrice", data).then(res => {
                        if (res) {
                            this.form.temp_order_transport_details = res;
                        } else {
                            this.form.temp_order_transport_details = [];
                        }
                        this.$store.dispatch("Order/save", {id: this.id, newDO: this.newDO})
                            .then(response => {
                                if (response) {
                                    this.goToOrderList();
                                    this.modalConfirmOrder.state = null;
                                } else {
                                    this.form.status_confirm = null;
                                    alert("ไม่สามารถบันทึกได้ กรุณาตรวจสอบ ดังนี้\n" +
                                        "1.รถเล็กไม่เกิน 3 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                        "2.รถใหญ่ไม่เกิน 1 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                        "3.มารับเองไม่เกิน 1 ใบต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n"
                                    );
                                    this.hideLoadingModal()
                                }

                            }).catch(() => {
                            this.showLoadingModal();
                            this.msg = 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง'
                            this.status_loading = 3;
                        });
                        this.$refs['confirm_submit_order'].hide();
                    });
                }
            } else {
                this.$store.dispatch("Order/save", {id: this.id, newDO: this.newDO})
                    .then(response => {
                        if (response) {
                            this.goToOrderList();
                            this.modalConfirmOrder.state = null;
                        } else {
                            this.form.status_confirm = null;
                            alert("ไม่สามารถบันทึกได้ กรุณาตรวจสอบ ดังนี้\n" +
                                "1.รถเล็กไม่เกิน 3 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                "2.รถใหญ่ไม่เกิน 1 คันต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n" +
                                "3.มารับเองไม่เกิน 1 ใบต่อ 1 ลูกค้าในการเปิดใบจอง (กรณที่ที่ใบจองยังไม่เปิดใบบิล)\n"
                            );
                            this.hideLoadingModal()
                        }

                    }).catch(() => {
                    this.showLoadingModal();
                    this.msg = 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง'
                    this.status_loading = 3;
                });
                this.$refs['confirm_submit_order'].hide();
            }
        },
        saveDraft() {
            this.$store.dispatch("Order/save", {id: this.id, newDO: this.newDO}).then(() => {
                this.goToOrderList();
            })
        },
        goToInvoiceForm() {
            this.$store.dispatch("Order/createInvoiceFromOrder").then(() => {
                this.$store.dispatch("Invoice/setIDFromOrder", this.form.id).then(() => {
                    this.$store.dispatch("Invoice/generateOrder").then(() => {
                        this.$router.push({
                            name: "invoice-form",
                            params: {createFromOrder: true}
                        });
                    });
                });
            });
        },
        goToOrderList() {
            this.$router.push("/orders");
        },
        calculatePromotion(detail) {
            this.on_loading = true;
            let uniq = this.form.details.length;
            if (detail) {
                detail.product_id = detail.product.id;
                detail.uniq = uniq + 1;
                let data = {
                    other_price_form: this.form.other_price_form,
                    details: detail,
                };
                this.$store.dispatch("Order/promotionOrder", data).then(() => {
                    if (this.detail.uniq == uniq + 2) {
                        this.form.details[data.details.uniq] = this.promotion_detail;
                    } else {
                        this.detail = this.promotion_detail; //รับค่า โปรโมชั่นมาใส่ details
                    }
                    this.on_loading = false;
                });
            } else {
                this.on_loading = false;
            }
        },
        calculatePromotionArray(details) {
            this.on_loading = true;
            if (details) {
                let data = {
                    other_price_form: this.form.other_price_form,
                    details: details
                };
                // this.test = data;
                this.$store.dispatch("Order/promotionOrderMultiple", data).then(() => {
                    this.getOrderTransportPrice();
                    this.on_loading = false;
                });
            } else {
                this.on_loading = false;
            }
        },
        calculatePromotionArray2(details) {
            if (details) {
                this.msg = 'กำลังคำนวนโปรโมชั่น';
                this.status_loading = 1;
                this.showLoadingModal();
                let data = {
                    other_price_form: this.form.other_price_form,
                    details: details
                };
                // this.test = data;
                this.$store.dispatch("Order/promotionOrderMultiple", data).then(() => {
                    this.getOrderTransportPrice();
                    this.hideLoadingModal()
                });
            }
        },
        selectOtherPrice() {
            if (this.detail.product) {
                this.calculatePromotion(this.detail);
            }
            if (this.form.details.length > 0) {
                this.calculatePromotionArray(this.form.details);
            }
        },
        getOrderBefore() {
            if (this.form.customer && this.form.transport_type && !this.form.id) {
                let data = {
                    customer_id: this.form.customer.id,
                    transport_type_id: this.form.transport_type.id
                };
                this.$store.dispatch("Order/getOrderBefore", data).then(() => {
                    this.getOrderTransportPrice();
                })
            }
        },
        getPromotionOther() {
            if (this.form.customer) {
                let sale_id = this.form.customer.sale_id;
                this.$store.dispatch("Order/getProductByPromotionOther", sale_id)
            }
        },
        getPromotionByProductId(product) {
            if (product) {
                let data = {
                    product_id: product.id,
                    sale_id: this.form.customer ? this.form.customer.sale_id : null,
                };
                this.detail.promotion_id = null;
                // //console.log(this.promotion_all_one)
                this.detail.option_promotion = [{
                    value: null,
                    text: "โปรโมชั่น"
                }];
                this.promotion_all_one.forEach(x => {
                    x.promotion_products.forEach(y => {
                        if ((y.product_id == data.product_id && y.sale_id == null) || (y.product_id == data.product_id && y.sale_id == data.sale_id)) {
                            let promotion = {
                                value: x.id,
                                text: x.name,
                            }
                            this.detail.option_promotion.push(promotion)
                        }
                    })
                })
                this.detail.option_promotion = [...new Map(this.detail.option_promotion.map(item => [item.value, item])).values()]
                // this.$store.dispatch("Promotion/setPromotionAll",data).then(()=>{
                //     this.detail.option_promotion = this.promotions;
                // });
            }
        },
        getOrderTransportPrice() {
            if (this.form.customer && !this.form.customer_other) {
                let customer_other = "";
                let fixed_rate_status = this.form.customer.fixed_rate_status;
                if (this.form.customer_other) {
                    customer_other = this.form.customer_other.id;
                    fixed_rate_status = this.form.customer_other.status_transport_form;
                }
                let data = {
                    customer_id: this.form.customer.id,
                    customer_other_id: customer_other,
                    fixed_rate_status: fixed_rate_status,
                    transport_type_id: this.form.transport_type ? this.form.transport_type.id : null,
                    status_transport_other: this.form.status_transport_other,
                    status_sale_receive: this.form.status_sale_receive,
                    details: this.form.details,
                    flag: 1 //มาจาก invoice เพื่อคำนวนค่าขนส่ง
                };
                this.data_transport_fee = data;
                if (!this.form.status_receive) {
                    this.$store.dispatch("Order/getOrderTransportPrice", data).then(res => {
                        if (res) {
                            this.transport_price_table = res;
                        } else {
                            this.transport_price_table = [];
                        }
                    });
                }
            } else if (this.form.customer && this.form.customer_other) {
                let customer_other = this.form.customer_other.id;
                let fixed_rate_status = this.form.customer_other.fixed_rate_status;
                let data = {
                    customer_id: this.form.customer.id,
                    customer_other_id: customer_other,
                    fixed_rate_status: fixed_rate_status,
                    transport_type_id: this.form.transport_type ? this.form.transport_type.id : null,
                    status_transport_other: this.form.status_transport_other,
                    status_sale_receive: this.form.status_sale_receive,
                    details: this.form.details,
                    flag: 1 //มาจาก invoice เพื่อคำนวนค่าขนส่ง
                };
                this.data_transport_fee = data;

                let all_false_1 = false;
                let all_false_2 = false;
                this.form.customer_other.customer_transport_form.forEach((x, i) => {
                    if (x.transport_type_wrap_id == 1 && x.price && !all_false_1) {
                        all_false_1 = true;
                    }
                    if (x.transport_type_wrap_id != 1 && x.price && !all_false_2) {
                        all_false_2 = true;
                    }
                })
                this.hideFixRate_customer_other_1 = !all_false_1;
                this.hideFixRate_customer_other_2 = !all_false_2;
                if (!all_false_1 && !all_false_2) this.form.customer_other.fixed_rate_status = null;

                if (!this.form.status_receive) {
                    this.$store.dispatch("Order/getOrderTransportPrice", data).then(res => {
                        if (res) {
                            this.transport_price_table = res;
                        } else {
                            this.transport_price_table = [];
                        }
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}

.text-primary {
    font-weight: bold;
}

.text-danger {
    font-weight: bold;
}

.padding {
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: 10px;
}

.total-padding {
    padding-right: 20px;
    text-align: right;
}

.transport-style {
    color: red;
}
</style>
